import { ActivityTagCell } from "PFApp/components/activity_tag_cell";
import { EngagementRolesBadge } from "PFComponents/role/engagement_roles_badge";
import { CellContext } from "PFComponents/table/table.types";
import { Engagement, WorkflowActivity } from "PFCore/types";

import { KPIsCell } from "./cells/kpis_cell";

export const getEngagementsCellRenderers = () => ({
  roles: ({ row }: CellContext<WorkflowActivity, unknown>) => (
    <EngagementRolesBadge engagement={row.original.activity as unknown as Engagement} />
  ),
  kpis: ({ row }: CellContext<WorkflowActivity, unknown>) => (
    <KPIsCell KPIs={(row.original.activity as unknown as Engagement).kpis} />
  ),
  activity_tag: ({ getValue }) => <ActivityTagCell value={getValue()} />
});
